/* GENERATED from memory/STATUS.md by gen-facts.mjs — do not edit.
 * The repo's rule: every countable fact lives in STATUS.md and nowhere else.
 */

export const FACTS: { value: string; label: string }[] = [
  {
    "value": "3",
    "label": "implementations, one signing vector, checked in CI"
  },
  {
    "value": "7",
    "label": "signed formats with cross-language test vectors"
  },
  {
    "value": "1,523",
    "label": "tests, green"
  },
  {
    "value": "8d",
    "label": "since the last shipped change"
  }
];
